import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';
import WebsiteLayoutWS from '../WebsiteLayoutWS';
import FeatureElement from '../components/FeatureElement';
import CallToAction from '../components/CallToAction';
import HeaderPage from '../components/HeaderPage';

const ToolsWs = ({ businessData }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <WebsiteLayoutWS>
      <Helmet>
        <title>CHEK UP - {t('toolsTitle')}</title>
        <meta
          name="description"
          content={t('metaDescription')}
        />
      </Helmet>
      <HeaderPage
        title={t('toolsTitle')}
        subtitle={t('toolsSubtitle')}
        caption={t('toolsCaption')}
      />
      <FeatureElement
        orientation="lr"
        title={t('tools1Title')}
        description={t('tools1Description')}
        image="/assets/chekup/Tools1.png"
        linkLabel={t('tools1Link')}
        linkUrl="/outils/rentabilite"
        listItems={[
          {
            title: t('tools1Item1Title'),
            description: t('tools1Item1Desc'),
          },
          {
            title: t('tools1Item2Title'),
            description: t('tools1Item2Desc'),
          },
          {
            title: t('tools1Item3Title'),
            description: t('tools1Item3Desc'),
          },
          {
            title: t('tools1Item4Title'),
            description: t('tools1Item4Desc'),
          },
        ]}
      />

      <FeatureElement
        orientation="rl"
        title={t('tools2Title')}
        description={t('tools2Description')}
        image="/assets/chekup/Tools2.png"
        linkLabel={t('tools2Link')}
        linkUrl="/outils/integrations"
        listItems={[
          {
            title: t('tools2Item1Title'),
            description: t('tools2Item1Desc'),
          },
          {
            title: t('tools2Item2Title'),
            description: t('tools2Item2Desc'),
          },
          {
            title: t('tools2Item3Title'),
            description: t('tools2Item3Desc'),
          },
        ]}
      />

      <FeatureElement
        orientation="lr"
        title={t('tools3Title')}
        description={t('tools3Description')}
        image="/assets/chekup/Tools3.png"
        linkLabel={t('tools3Link')}
        linkUrl="/outils/gestion-inventaire"
        listItems={[
          {
            title: t('tools3Item1Title'),
            description: t('tools3Item1Desc'),
          },
          {
            title: t('tools3Item2Title'),
            description: t('tools3Item2Desc'),
          },
        ]}
      />

      <FeatureElement
        orientation="rl"
        title={t('tools4Title')}
        description={t('tools4Description')}
        image="/assets/chekup/Tools4.png"
        linkLabel={t('tools4Link')}
        linkUrl="/outils/solutions-specialisees"
        listItems={[
          {
            title: t('tools4Item1Title'),
            description: t('tools4Item1Desc'),
          },
          {
            title: t('tools4Item2Title'),
            description: t('tools4Item2Desc'),
          },
        ]}
      />

      <CallToAction
        title={t('ctaTitle')}
        description={t('ctaDescription')}
        primaryButtonText={t('ctaPrimaryButton')}
        primaryButtonLink="/onboard"
        secondaryButtonText={t('ctaSecondaryButton')}
        secondaryButtonLink="/demo"
      />
    </WebsiteLayoutWS>
  );
};

export default ToolsWs;
